/**
 * en-GB messages added by shared reception task S-SR2 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const sSr2EnGB = {};
//# sourceMappingURL=s-sr2.js.map